import { audienceBuilderConfig } from './config'
import { Rule } from './types'

export const getOperators = (ruleValue: string) => {
  const rule = audienceBuilderConfig
    ?.map((ruleGroup) => ruleGroup.options)
    .flat(2)
    .find((r) => r.value === ruleValue)
  return rule ? rule.operators : []
}

export const getRuleFromConfig = (ruleName: string): Rule | undefined => {
  return audienceBuilderConfig
    ?.map((ruleGroup) => ruleGroup.options)
    .flat(2)
    .find((r) => r.value === ruleName)
}
